import React from 'react';
import { Table, Input, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';

class TablaUsuarios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      verFiltroOrganismo: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarUsername: '',
      textoBuscarOrganismo: '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onUsernameChange = e => {
    this.setState({ textoBuscarUsername: e.target.value });
  };

  onOrganismoChange = e => {
    this.setState({ textoBuscarOrganismo: e.target.value });
  };

  render() {
    const columns = [
      {
        title: 'Usuario',
        dataIndex: 'username',
        key: 'username',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar Usuario"
              value={this.state.textoBuscarUsername}
              onChange={this.onUsernameChange}
              onPressEnter={() =>
                this.props.filtrarPorUsername(this.state.textoBuscarUsername)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorUsername(this.state.textoBuscarUsername)
              }
            >
              Buscar Usuario
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroDocumento,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroDocumento: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
        render: text => text.toUpperCase(),
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar nombre"
              value={this.state.textoBuscarNombre}
              onChange={this.onInputChange}
              onPressEnter={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorNombre(this.state.textoBuscarNombre)
              }
            >
              Buscar
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.filterDropdownVisible,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              filterDropdownVisible: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Apellido',
        dataIndex: 'apellido',
        key: 'apellido',
        render: text => text.toUpperCase(),
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar Apellido"
              value={this.state.textoBuscarApellido}
              onChange={this.onApellidoChange}
              onPressEnter={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorApellido(this.state.textoBuscarApellido)
              }
            >
              Buscar Apellido
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroApellido,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroApellido: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Rol',
        dataIndex: 'rol',
        key: 'rol',
      },
      {
        title: 'Organismo',
        dataIndex: ['organismo', 'nombre'],
        key: 'organismo',
        filterDropdown: (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Buscar por Organismo"
              value={this.state.textoBuscarOrganismo}
              onChange={this.onOrganismoChange}
              onPressEnter={() =>
                this.props.filtrarPorOrganismo(this.state.textoBuscarOrganismo)
              }
            />
            <Button
              type="primary"
              onClick={() =>
                this.props.filtrarPorOrganismo(this.state.textoBuscarOrganismo)
              }
            >
              Buscar por Organismo
            </Button>
          </div>
        ),
        filterIcon: (
          <Icons.FilterOutlined
            style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }}
          />
        ),
        filterDropdownVisible: this.state.verFiltroOrganismo,
        onFilterDropdownVisibleChange: visible => {
          this.setState(
            {
              verFiltroOrganismo: visible,
            },
            () => this.searchInput && this.searchInput.focus()
          );
        },
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(`/admin/usuarios/${record._id}`)
              }
            >
              Editar
            </Button>
          </span>
        ),
      },
    ];
    const { usuarios } = this.props;

    return (
      <Table
        size="small"
        rowKey="_id"
        columns={columns}
        pagination={this.props.pagination}
        dataSource={usuarios}
        title={() => <h2 style={{ textAlign: 'center' }}> Usuarios </h2>}
        locale={{
          emptyText: 'No hay usuarios cargados',
        }}
        loading={this.props.loading}
      />
    );
  }
}

export default TablaUsuarios;
